import Vue from "vue";

export async function fetchBenefits({ commit }, full_legal_number) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/benefits?view_as=${full_legal_number}`
    })
    commit('setBenefits', data)
  } catch (error) {
    commit('BenefitsError', error.message)
  } finally {
    // // console.log('La peticion de grupo de beneficios ha finalizado')
  }
}

export async function fetchBenefit({ commit }, params) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/benefits/benefit?id=${params.id}&view_as=${params.full_legal_number}`
    });
    commit("setBenefit", data);
  } catch (e) {
    commit("benefitError", e.message);
  } finally {
    // // console.log("La petición para obtener el beneficio ha finalizado");
  }
}

export function changeBenefitTypeScroll({ commit }, benefit_type) {
  commit("setBenefitTypeScroll", benefit_type);
}

